import React from 'react';

// Rendered as a direct child of MUI <Fade>, which clones the child with a ref
// (and a style prop) to drive the transition. A plain function component can't
// hold that ref, so Fade's onEnter would read `null.scrollTop` and crash the
// page. forwardRef + prop spread keeps the ref and the fade styles attached.
const ProjectorAcknowlegingTxt = React.forwardRef((props, ref) => (
    <span ref={ref} {...props}>
      By continuing , you acknowledge that you have read and understood the
      &nbsp;
      <a
        style={{ color: '#5AA5EF ' }}
        target="_blank"
        rel="noreferrer"
        href="http://app.projectorstream.com.s3-website-us-west-2.amazonaws.com/settings/terms-of-use"
      >
        Terms of Use
{' '}
      </a>
      ,&nbsp;
      <a
        style={{ color: '#5AA5EF ' }}
        target="_blank"
        rel="noreferrer"
        href="https://projector.app/privacy"
      >
        Privacy Policy
{' '}
      </a>
{' '}
      &nbsp;and &nbsp;
      <a
        style={{ color: '#5AA5EF ' }}
        target="_blank"
        rel="noreferrer"
        href="http://app.projectorstream.com.s3-website-us-west-2.amazonaws.com/settings/terms-of-use "
      >
        Subscriber Agreement.
      </a>
    </span>
  ));

ProjectorAcknowlegingTxt.displayName = 'ProjectorAcknowlegingTxt';

export default ProjectorAcknowlegingTxt;
